import {
  ReviewForgeElementType,
  SystemSemanticTagId,
} from "@redotech/redo-content-builder-common/forge/review-forge-types";
import {
  ReviewFieldSchemaType,
  reviewRatingToNumber,
} from "@redotech/redo-review-db-schema/review";
import { ReviewBody } from "@redotech/redo-review-db-schema/review-body-schema";
import { PossibleSubmittableData } from "@redotech/redo-web/reviews-form/review-form-types";

export function reviewToFormData(
  review: ReviewBody,
): Record<string, PossibleSubmittableData> {
  const formData: Record<string, PossibleSubmittableData> = {};

  for (const field of review.reviewFields) {
    switch (field.fieldType) {
      case ReviewFieldSchemaType.REVIEW_SHORT_ANSWER:
        formData[field.semanticTagId] = {
          type: ReviewForgeElementType.SHORT_ANSWER,
          answer: field.text,
        };
        break;
      case ReviewFieldSchemaType.REVIEW_PARAGRAPH:
        formData[field.semanticTagId] = {
          type: ReviewForgeElementType.PARAGRAPH,
          value: field.text,
        };
        break;
      case ReviewFieldSchemaType.REVIEW_RATING:
        formData[field.semanticTagId] = {
          type: ReviewForgeElementType.STARS,
          rating: reviewRatingToNumber(field.rating),
        };
        break;
      case ReviewFieldSchemaType.REVIEW_SINGLE_CHOICE:
        formData[field.semanticTagId] = {
          type: ReviewForgeElementType.SINGLE_SELECT,
          selectedOption: field.text,
        };
        break;
      case ReviewFieldSchemaType.REVIEW_MEDIA_UPLOAD:
        // For media uploads, we store each URL as a separate entry
        formData[field.semanticTagId] = {
          type: ReviewForgeElementType.MEDIA_UPLOAD,
          url: field.text,
        };
        break;
    }
  }

  // Add customer email if available
  if (review.customer?.email) {
    formData[SystemSemanticTagId.REVIEW_EMAIL] = {
      type: ReviewForgeElementType.SHORT_ANSWER,
      answer: review.customer.email,
    };
  }

  return formData;
}
